export const LineChartTooltip = ({ label, payload, active }) => {
  if (active && payload && payload.length) {
    return (
      <div className="bg-[#161D17] border border-[#E1E6E1] rounded-lg p-4 shadow-lg">
        <p className="text-sm font-semibold text-[#FFFFFF] mb-3">{label}</p>
        
        <div className="space-y-2">
          {payload.map((entry, index) => {
            // Handle different data structures
            let displayLabel = "";
            let displayValue = entry.value;
            let dotColor = entry.color;
            
            if (entry.dataKey === "in_stock") {
              displayLabel = "In Stock";
              dotColor = "#2B8C34";
            } else if (entry.dataKey === "out_of_stock") {
              displayLabel = "Out of Stock";
              dotColor = "#B92020";
            } else if (entry.dataKey === "value") {
              displayLabel = "Stock Moved";
              dotColor = "#2B8C34";
            } else if (entry.dataKey === "total") {
              displayLabel = "Total Stock";
              dotColor = "#2B8C34";
            } else {
              displayLabel = entry.dataKey;
            }

            return (
              <div key={index} className="flex items-center justify-between">
                <div className="flex items-center gap-2">
                  <div 
                    className="w-3 h-3 rounded-full" 
                    style={{ backgroundColor: dotColor }}
                  ></div>
                  <p className="text-xs font-medium text-[#FFFFFF]">{displayLabel}</p>
                </div>
                <p className="text-xs font-semibold text-[#FFFFFF] ml-2">
                  {displayValue?.toLocaleString() || "0"}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    );
  }

  return null;
};